import { authGet } from "@shared/api";
import { SelectItemData } from "@shared/components";
import { NOTIFICATIONS_URL } from "@shared/constants";

interface NangoProject {
  key: string;
  id: string;
}

export const fetchNangoProjects = async (
  deploymentId: number,
  ticketingInstanceId: string,
  subdomain: string | null,
  issueTypeId?: string
): Promise<SelectItemData[]> => {
  return authGet<NangoProject[]>(
    `${NOTIFICATIONS_URL}/${deploymentId}/ticketing/v2/${ticketingInstanceId}/projects?subdomain=${subdomain}&issue_type_id=${
      issueTypeId ?? ""
    }`
  ).then((projects: NangoProject[]) =>
    projects.map((project) => ({
      label: project.key,
      value: project.id,
    }))
  );
};
